import { useEffect } from 'preact/hooks'
import { on, openModal } from 'helpers/dom'
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'

const selectors = {
  MODAL_BOOKING_SELECTOR: '#book-appointment'
}

export default function ModalBookingLayout() {
  const { bookingAppointment } = translate

  useEffect(() => {
    on(
      'hashchange',
      () => {
        const hash = window.location.hash

        if (!hash) return

        if (hash === selectors.MODAL_BOOKING_SELECTOR) {
          openModal(hash)
          window.history.replaceState(null, null, ' ')
        }
      },
      window
    )
  }, [])

  return (
    <CustomModalDialog
      id={selectors.MODAL_BOOKING_SELECTOR}
      scrollTarget="modal-booking-inner"
      classModal="modal-dialog-slideout-booking !z-[54]"
      classMain="w-full !bg-grey-100 md:w-[376px] 2xl:w-[475px]"
      classIcon="size-[18px] text-primary"
      classClose="top-3 right-3 size-8 p-2"
      content={<ModalContent />}
      classContent="max-h-full overflow-auto"
      classHeader="w-full relative pb-4 pt-[17px] border-b border-primary-300 text-center px-5 font-medium uppercase text-primary"
      type="slideout"
      title={bookingAppointment.title}
      header={bookingAppointment.title}
    />
  )
}

function ModalContent() {
  const { bookingAppointment } = translate

  return (
    <div className="px-4 py-6 lg:p-8">
      <p className="mb-3 font-heading text-lg uppercase text-primary">{bookingAppointment.selectYourCity}</p>
      <div className="flex flex-col gap-4">
        {bookAppointmentData.map((bookAppointment, index) => (
          <a
            className="button-outlined pointer-events-auto text-primary"
            key={`${bookAppointment.title} - ${index}`}
            href={bookAppointment.url}
            target="_blank"
          >
            {bookAppointment.title}
          </a>
        ))}
      </div>
    </div>
  )
}
